import React, { useContext, useCallback } from 'react';
import _ from 'lodash';
import { wizardProps } from '@xengage/gw-portals-wizard-react';
import { ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import { useValidation } from '@xengage/gw-portals-validation-react';
import { readViewModelValue } from '@xengage/gw-jutro-adapters-react';
import { withRouter } from 'react-router-dom';
import styles from '../../../pages/Commercial/CommercialPage.module.scss';
// import AdvanceComponent from "../ADVANCE/ADVANCEComponent";
// import BasicComponent from "../BASIC/BASICComponent";
// import FurtherComponent from "../FURTHER/FURTHERComponent";

import metadata from './TechnologyComponent.metadata.json5';

import { BreakpointTrackerContext } from '@jutro/legacy/layout';

function TechnologyComponent(props) {

    const { submissionVM, updateWizardData, pathUpdated, isValidationRequired } = props;
    const breakpoint = useContext(BreakpointTrackerContext);
    const { onValidate } = useValidation('TechnologyComponent');
    const modelVM = _.get(submissionVM, pathUpdated)

    modelVM.value.isValidationReq = isValidationRequired


    // eslint-disable-next-line react-hooks/exhaustive-deps
    const overrideProps = {
        '@field': {
            showRequired: true,
            labelPosition: breakpoint === 'desktop' ? 'left' : 'top'
        },
        ifNOisallendsegandoffFie: {
            visible: !_.isUndefined(modelVM.areallcominyouorgrlatFie.value) && !modelVM.areallcominyouorgrlatFie.value
        },
        ifYEShavyouenamulaaccFie: {
            visible: !_.isUndefined(modelVM.doyouusecloemaserewebFie.value) && modelVM.doyouusecloemaserewebFie.value
        },
        ifYESdoyoureqmulauconFie: {
            visible: !_.isUndefined(modelVM.doyouallremacctoyohomFie.value) && modelVM.doyouallremacctoyohomFie.value
        },
        ifYESplestawhiproiSenFie: {
            visible: !_.isUndefined(modelVM.doyouutinexgenantotooFie.value) && modelVM.doyouutinexgenantotooFie.value
        },
        ifYESplestawhisofaenaFie: {
            visible: !_.isUndefined(modelVM.doyouutiemafiltooasofFie.value) && modelVM.doyouutiemafiltooasofFie.value
        },
        ifNOdoalllocadmaccpasFie: {
            visible: !_.isUndefined(modelVM.havyoudisalllocadmserFie.value) && modelVM.havyoudisalllocadmserFie.value === false
        },
        ifYESdoyoutakfrebaserFie: {
            visible: !_.isUndefined(modelVM.doyourunanyverofWiSerFie.value) && modelVM.doyourunanyverofWiSerFie.value
        },
        ifYESdoalllogatttoMFAFie: {
            visible: !_.isUndefined(modelVM.doyourunanyverofWiSerFie.value) && modelVM.doyourunanyverofWiSerFie.value
        }
    };


    const resolvers = {
        resolveCallbackMap: {
            onValidate
        },
        resolveComponentMap: {
            // basicComponent: BasicComponent,
            // furtherComponent: FurtherComponent,
            // advanceComponent: AdvanceComponent
        },
        resolveClassNameMap: styles
    };

    const readValue = useCallback(
        (id, path) => readViewModelValue(metadata.componentContent, _.get(submissionVM, pathUpdated), id, path, overrideProps),
        [overrideProps, pathUpdated, submissionVM]
    );

    const handleValueChange = useCallback(
        (value, changedPath) => {
            const fullPath = `${pathUpdated}.${changedPath}`;

            _.set(submissionVM, `${fullPath}`, value);

            updateWizardData(submissionVM);
        },
        [pathUpdated, submissionVM, updateWizardData]
    );

    return (
        <ViewModelForm
            uiProps={metadata.componentContent}
            model={modelVM}
            resolveValue={readValue}
            overrideProps={overrideProps}
            onValidationChange={onValidate}
            onValueChange={handleValueChange}
            callbackMap={resolvers.resolveCallbackMap}
            componentMap={resolvers.resolveComponentMap}
            classNameMap={resolvers.resolveClassNameMap}
        />
    );


}

TechnologyComponent.propTypes = wizardProps;
export default withRouter(TechnologyComponent);
